import { faker } from '@faker-js/faker';
import moment from 'moment-timezone';
import visitorsClassicScenario from './visitors-classic';

/**
 * Sets up Rules Alerting Mirage Scenario
 * - `MIRAGE_SCENARIO='rules-alerting' yarn start:mirage`
 *
 * @param {object} server Mirage Server
 */
export default function (server) {
  const {
    company,
    locations: [location],
    flows: [flow],
    subscription,
  } = visitorsClassicScenario(server);

  subscription.update({
    trialEndDate: null,
    last4: '1234',
    expirymonth: 10,
    expiryyear: 2019,
    brand: 'Visa',
    plan: 'enterprise',
    period: 'yearly',
    couponPercentOff: 10,
    features: [
      'billing',
      'sign_in_visitors',
      'custom_notifications',
      'group_sign_in',
      'nda_enabled',
      'visitor_photos',
      'visitor_badge_printing',
      'sms_notification',
      'slideshows',
      'custom_badge',
      'presign_nda',
      'multiple_visitor_types',
      'sign_in_from_invite',
      'slack',
      'analytics',
      'assistants',
      'blacklist',
      'locations_grouping',
      'conditional_alerts',
    ],
  });

  location.update({
    printerIds: [],
    visitorsOnboardingComplete: false,
    flowIds: [flow.id],
  });

  const signInFieldPage = server.create('sign-in-field-page');
  const newFlow = server.create('flow', { locationId: location.id, signInFieldPage, enabled: true, position: 4 });

  const options = [];
  for (var i = 9; i >= 1; i--) {
    options.push({ id: `${i}`, value: `option ${i}` });
  }

  const _field1 = server.create('sign-in-field', 'asSingleSelectionWithOptions', {
    signInFieldPage,
    position: 1,
  });

  const _field2 = server.create('sign-in-field', 'asSingleSelectionWithOptions', {
    signInFieldPage,
    position: 2,
  });

  const _field3 = server.create('sign-in-field', 'asSingleSelectionWithOptions', {
    signInFieldPage,
    position: 3,
  });

  const contact = server.create('sign-in-field-actions-contact', 1);
  const rule1 = server.create('sign-in-field-action-rule-group', 1, {
    flow: newFlow,
    signInFieldActionsContactIds: [contact.id],
  });
  const rule2 = server.create('sign-in-field-action-rule-group', 1, {
    flow: newFlow,
    signInFieldActionsContactIds: [contact.id],
  });
  const rule3 = server.create('sign-in-field-action-rule-group', 1, {
    flow: newFlow,
    signInFieldActionsContactIds: [contact.id],
    ignore: true,
  });

  server.create('sign-in-field-action', {
    signInFieldId: _field1.id,
    signInFieldActionRuleGroup: rule1,
    action: 'deny_entry',
    matchOperator: 'is',
    signInFieldValue: faker.lorem.words,
  });

  server.create('sign-in-field-action', {
    signInFieldId: _field2.id,
    signInFieldActionRuleGroup: rule2,
    action: 'deny_entry',
    matchOperator: 'is',
    signInFieldValue: faker.lorem.word,
  });

  server.create('sign-in-field-action', {
    signInFieldId: _field3.id,
    signInFieldActionRuleGroup: rule2,
    action: 'deny_entry',
    matchOperator: 'is',
    signInFieldValue: faker.lorem.words,
  });

  server.create('sign-in-field-action', {
    signInFieldId: _field3.id,
    signInFieldActionRuleGroup: rule3,
    action: 'deny_entry',
    matchOperator: 'is',
    signInFieldValue: 'yes',
  });

  server.create('invite', {
    arrived: false,
    fullName: 'First Last',
    location: newFlow.location,
    approvalStatus: { status: 'review' },
    expectedArrivalTime: moment().add(5, 'hours').format(),
  });

  server.create('entry', {
    arrived: false,
    fullName: 'First Last',
    location: newFlow.location,
    approvalStatus: { status: 'review' },
    expectedArrivalTime: moment().add(5, 'hours').format(),
  });

  server.create('company-config', {
    hasConnectedCalendarAccount: false,
    provider: 'google',
    connectedEmailAccount: 'foo@bar.com',
  });

  server.create('connection', { companyId: company.id });
  server.create('room-location-config');

  server.create('flow', 'withQuestions', { type: 'Flows::EmployeeScreening', location });

  const bob = server.create('user', { name: 'bob ross' });
  server.create('employee', { companyId: company.id, name: 'bob ross', user: bob, locations: [location] });
}
